(function () {
    'use strict';

    function OrderBagItemOptionCustomController($scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItemCustom) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.allOptions = [];
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.optionsNoQty = [];
        $ctrl.optionsWithQty = [];
        $ctrl.getQtyList = getQtyList;
        $ctrl.onQtyChange = onQtyChange;


        loadAll();
        loadPage();


        //$scope.$watch('$ctrl.serviceOptionItems', function () {
        //    console.log('$ctrl.serviceOptionItems watched');
        //    setSelectedItems();
        //
        //}, true);

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceOptionItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

            loadData();

        }

        function loadData() {
            $ctrl.optionsNoQty = []
            $ctrl.optionsWithQty = []
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null)
                $ctrl.allOptions = [];
            else {
                ServiceOptionItemCustom.ServiceOptionItemsByServiceItem($ctrl.serviceItemId).query(function (result) {
                    //$ctrl.allOptions = result;
                    angular.forEach(result, function (item) {
                        if (item.qtyType && item.qtyType == "HAS_QTY") {
                            $ctrl.optionsWithQty.push(item);
                            item.selected = true;
                        } else
                            $ctrl.optionsNoQty.push(item);
                    })

                    setOptions();
                });

            }
        }

        function setOptions() {
            var options = $ctrl.optionsNoQty.concat($ctrl.optionsWithQty);
            $ctrl.serviceOptionItems = options;
        }

        function onCheckChanged() {

            if ($ctrl.onSelectedChange) {
                $ctrl.onSelectedChange();

            }
            //$ctrl.serviceOptionItems = $ctrl.allOptions.filter(function (v) {
            //    return (v.selected == true)
            //});

        }

        function onQtyChange() {
            if ($ctrl.onSelectedChange) {
                $ctrl.onSelectedChange();
            }
        }

        function getQtyList(option) {
            var qtyList = [];
            for (var i = 0; i <= option.maxQty; i++) {
                qtyList.push(i);
            }
            return qtyList;
        }

        function setSelectedItems() {

            //if($ctrl.serviceOptionItems ==null || $ctrl.serviceOptionItems ==undefined)
            //    return;
            //
            //angular.forEach($ctrl.serviceOptionItems, function (p) {
            //    var filtered = $ctrl.allOptions.filter(function (v) {
            //        return(v.id == p.id)
            //    });
            //    if(filtered.length>0)
            //    {
            //        filtered[0].selected = true;
            //    }
            //});
        }

        $scope.$watch('$ctrl.serviceItemId', function (si) {
            loadData();
        });

        $scope.$watch('$ctrl.optionsNoQty', function () {
            setOptions();
        });
        $scope.$watch('$ctrl.optionsWithQty', function () {
            setOptions();
        });

    }

    var OrderBagItemOptions = {
        templateUrl: 'app/components/partial-forms/orderbag-item-options/partial-form.orderbag-item-options.html',
        controller: OrderBagItemOptionCustomController,
        bindings:
            {
                serviceItemId: '<',
                serviceOptionItems: '=',
                onSelectedChange: "&"
            }

    };

    angular
        .module('tikonApp')
        .component('pfOrderBagItemOptions', OrderBagItemOptions)

    OrderBagItemOptionCustomController.$inject = ['$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItemCustom'];


})();

